import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';

export default class UserService extends Component {
  static createUser = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/sites_create_users?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static updateUser = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/update_userdata?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };
  static updateNoti = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/update_notification_flag?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = '';
      config.params = data;
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };
  static getUsersList = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_users?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getNotifications = async () => {
    try {
      config.url = baseUrl + '/wp/v2/get_general_notifications?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = '';
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getUsersDetail = async (id) => {
    try {
      config.url = baseUrl + '/wp/v2/userdetail?id=' + id;
      config.method = 'get';
      config.params = '';
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllUsersByCountry = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/practioner_cat_stats?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllCenters = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/center_cat_stats?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  }
}
